// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__1WMad","info":"Note_info__3MNqZ","note":"Note_note__304eT","actions":"Note_actions__37dgL"};